firebird.controller('mobileHostAccountCtrl', [
    '$window',
    '$scope',
    '$state',
    '$stateParams',
    '$http',
    '$timeout',
    'meetingService',
    'helperService',
    'hostsAPIService',
    'routerService',
    'attendeeService',
    'meetingAPIService',
    'logService',
    'analyticsWrapperService',
    'timeZoneService',
    'cookieService',
    function (
        $window,
        $scope,
        $state,
        $stateParams,
        $http,
        $timeout,
        meetingService,
        helperService,
        hostsAPIService,
        routerService,
        attendeeService,
        meetingAPIService,
        logService,
        analyticsWrapperService,
        timeZoneService,
        cookieService
    ) {
        const logger = logService.createLoggerWithSource('mobileHostAccountCtrl');

        var self = this;

        self.userInfo = {};
        self.activeMeeting = null;
        self.scheduledMeetings = null;
        self.refresh = refresh;
        self.meetingCode = '';

        //General Stuff
        self.init = init;
        self.getAppLogoURL = getAppLogoURL;
        self.getAppLogoIconURL = getAppLogoIconURL;
        self.getAppLogoIconTitle = getAppLogoIconTitle;
        self.getHostIconURL = getHostIconURL;

        //Account Page
        self.getActiveMeeting = getActiveMeeting;
        self.getScheduledMeetings = getScheduledMeetings;
        self.logOut = logOut;
        self.getHostDetails = getHostDetails;
        self.getShortcutURL = getShortcutURL;
        self.getHostName = getHostName;
        self.getDialInInformation = getDialInInformation;
        self.getAdditionalMessageText = getAdditionalMessageText;
        self.getHostImage = getHostImage;
        self.getStartMeetingButtonTitle = getStartMeetingButtonTitle;
        self.dialOut = dialOut;
        self.share = share;
        self.shouldDisable = shouldDisable;

        //tab state
        self.setActiveTab = setActiveTab;
        self.isInTabState = isInTabState;
        self.activeTab = 'meeting';

        //start/join meeting
        self.startQuickMeeting = startQuickMeeting;
        self.joinMeeting = joinMeeting;
        self.startScheduledMeeting = startScheduledMeeting;

        self.digest = digest;

        self.onHandleOpenURL = onHandleOpenURL;

        $window.document.addEventListener('handleopenurl', self.onHandleOpenURL);
        $window.document.addEventListener('sticky-handleopenurl', self.onHandleOpenURL);

        $scope.$on('$destroy', function () {
            $window.document.removeEventListener('handleopenurl', self.onHandleOpenURL);
            $window.document.removeEventListener('sticky-handleopenurl', self.onHandleOpenURL);
        });

        init();

        ////////////////////////

        function onHandleOpenURL(e) {
            var launchUrl = e && e.detail ? e.detail : '';

            if (launchUrl) {
                if (launchUrl === 'https://www.anymeeting.com/?utm_source=mobile_sign_up') {
                    return;
                }

                var recordingId = helperService.getRecordingId(launchUrl);
                if (recordingId && recordingId !== 'unknown') {
                    $state.go('meeting-login');
                    return;
                }

                var meetingIdentifier = helperService.getMeetingIdentifier(launchUrl);
                if (meetingIdentifier !== 'unknown') {
                    $timeout(function () {
                        self.meetingCode = meetingIdentifier;
                        self.setActiveTab('join');
                        $window.document.removeEventListener('sticky-handleopenurl', self.onHandleOpenURL);
                        helperService.refreshStickyEventListeners();
                    }, 500);
                }
            }
        }

        function refresh() {
            self.getHostDetails();
            self.getActiveMeeting();
            self.getScheduledMeetings();
            self.digest();
        }

        function isInTabState(tab) {
            return tab === self.activeTab;
        }

        function setActiveTab(tab) {
            self.activeTab = tab;
            self.digest();
        }

        function init() {
            self.setActiveTab('meeting');
            self.getHostDetails();
            self.getActiveMeeting();
            self.getScheduledMeetings();

            analyticsWrapperService.initMobileAnalytics();
        }

        function getAppLogoURL() {
            if (meetingService.isIntermediaPLRUser()) {
                return 'img/logos/plr_logo.svg';
            } else {
                return 'img/logos/im_logo.svg';
            }
        }

        function getHostIconURL() {
            var state = '';
            if (self.activeTab === 'meeting') {
                state = '_active';
            }
            if (meetingService.isIntermediaPLRUser()) {
                return 'img/icons/host_plr' + state + '.png';
            } else {
                return 'img/icons/host_im' + state + '.png';
            }
        }

        function getAppLogoIconURL() {
            if (meetingService.isIntermediaPLRUser()) {
                return 'img/icons/icon_plr.png';
            } else {
                return 'img/icons/icon_im.png';
            }
        }

        function getAppLogoIconTitle() {
            if (meetingService.isIntermediaPLRUser()) {
                return 'Online Meeting';
            } else {
                return 'Intermedia AnyMeeting';
            }
        }

        function startQuickMeeting() {
            var message;
            var title;
            if (self.activeMeeting !== null) {
                message = 'Are you sure you want to join the active meeting?';
                title = 'Join meeting';
            } else {
                message = 'Are you sure you want to start a meeting?';
                title = 'Start Meeting';
            }
            helperService.mobileConfirm(message, title, function (response) {
                if (response === 1) {
                    analyticsWrapperService.eventTrack('Meeting - Mobile Host - Start Quick Meeting', {
                        category: 'Mobile Host'
                    });

                    hostsAPIService
                        .startQuickMeeting()
                        .then(function (mac) {
                            logger.log('meetingaccesscode: ' + mac);
                            attendeeService.setAttendeeType('host');
                            routerService
                                .resolveInitialPath(mac.replace(/-/g, ''))
                                .then(function (meeting) {
                                    //logger.log('Meeting Object: ' + meeting);
                                    meetingService.init(meeting);
                                })
                                .catch(function (err) {
                                    logger.log('resolveInitialPath err:', err);
                                });
                        })
                        .catch(function (e) {
                            logger.error('startQuickMeeting', 'Error', e);
                        });
                }
            });
        }

        function startScheduledMeeting(accesscode) {
            helperService.mobileConfirm(
                'Are you sure you want to start this meeting?',
                'Start Scheduled Meeting',
                function (response) {
                    if (response === 1) {
                        analyticsWrapperService.eventTrack('Meeting - Mobile Host - Start Scheduled Meeting', {
                            category: 'Mobile Host'
                        });

                        hostsAPIService
                            .startScheduledMeeting({
                                meetingAccessCode: accesscode
                            })
                            .then(function (mac) {
                                logger.log('meetingaccesscode: ' + mac);
                                attendeeService.setAttendeeType('host');

                                //TODO:
                                //This function has a 'mac' param but doesn't use it...
                                //Instead, the outer param 'accesscode' is used...
                                //Might want to either use the 'mac' param, or make sure they match,
                                //Or lose the reference to the 'mac' param altogether?

                                routerService
                                    .resolveInitialPath(accesscode.replace(/-/g, ''))
                                    .then(function (meeting) {
                                        //logger.log('Meeting Object: ' + meeting);
                                        meetingService.init(meeting);
                                    })
                                    .catch(function (err) {
                                        logger.log('resolveInitialPath err:', err);
                                    });
                            })
                            .catch(function (e) {
                                logger.error('startScheduledMeeting', 'Error', e);
                            });
                    }
                }
            );
        }

        function getActiveMeeting() {
            hostsAPIService
                .getActiveMeeting()
                .then(function (meeting) {
                    if (meeting) {
                        self.activeMeeting = meeting.data;
                        self.activeMeeting.startDate = $window.moment(self.activeMeeting.startDate).format('h:mm A');
                    }
                })
                .catch(function (e) {
                    //TODO: Log the error?
                    self.activeMeeting = null;
                })
                .finally(function () {
                    self.digest();
                });
        }

        function getHostDetails() {
            hostsAPIService
                .getHostDetails()
                .then(function (host) {
                    self.userInfo = host;
                    $window.localStorage.setItem('fullname', host.fullname);
                    $window.localStorage.setItem('email', host.email);
                    self.digest();
                })
                .catch(function (e) {});
        }

        function getShortcutURL() {
            if (self.userInfo.shortcutURL) {
                return helperService.getLocationHost() + '/' + self.userInfo.shortcutURL;
            }
            return '';
        }

        function getHostName() {
            if (self.userInfo.fullname) {
                return self.userInfo.fullname;
            }
            return '';
        }

        function share() {
            //construct message

            var meetingUrl =
                'Meeting URL: ' +
                'https://www.' +
                helperService.getLocationHost() +
                '/' +
                self.userInfo.shortcutURL +
                '\n';
            var joinByPhone =
                'Join by phone: ' + self.userInfo.numberToll + ' ' + 'Pin: ' + self.userInfo.attendeePIN + '\n';
            var quickDial =
                'Quick dial: ' + self.userInfo.numberToll + ',,' + self.userInfo.attendeePIN.replace(' ', '') + '#';
            var message = meetingUrl + joinByPhone + quickDial;
            // this is the complete list of currently supported params you can pass to the plugin (all optional)
            var options = {
                message: message, // not supported on some apps (Facebook, Instagram)
                subject: 'Please join this meeting', // fi. for email
                files: [], // an array of filenames either locally or remotely
                url: ''
                ////chooserTitle: 'Pick an app', // Android only, you can override the default share sheet title,
                //appPackageName: 'com.apple.social.facebook' // Android only, you can provide id of the App you want to share with
            };

            var onSuccess = function (result) {
                logger.log('Share completed? ' + result.completed); // On Android apps mostly return false even while it's true
                logger.log('Shared to app: ' + result.app); // On Android result.app since plugin version 5.4.0 this is no longer empty. On iOS it's empty when sharing is cancelled (result.completed=false)
            };

            var onError = function (msg) {
                logger.error(
                    'share: window.plugins.socialsharing.shareWithOptions.onError',
                    'Sharing failed with message',
                    msg
                );
            };

            $window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
        }

        function getDialInInformation() {
            if (self.userInfo.numberToll && self.userInfo.presenterPIN) {
                return self.userInfo.numberToll + ' Pin: ' + self.userInfo.presenterPIN + '#';
            }
            return '';
        }

        function dialOut() {
            $window.open(
                'tel:' +
                    self.userInfo.numberToll.replace(/[ -]/g, '') +
                    ',,' +
                    self.userInfo.presenterPIN.replace(/[ -]/g, '') +
                    '#',
                '_system'
            );
        }

        function getHostImage() {
            //TODO: Why not just reference the ctrl var directly instead of returning it in a function call? :(
            return self.userInfo.imageURL;
        }

        function getStartMeetingButtonTitle() {
            return self.activeMeeting == null ? 'Start a meeting' : 'Enter active meeting';
        }

        function getScheduledMeetings() {
            var filteredMeetings = [];
            var currentDate = $window.moment();
            hostsAPIService
                .getUpcomingMeetings()
                .then(function (meetings) {
                    for (var i = 0; i < meetings.length; i++) {
                        if (meetings[i].meetingType !== 1 && meetings[i].meetingType !== 3) {
                            continue;
                        }
                        var timezone = timeZoneService.convertToTimezoneObj(meetings[i].timeZone);
                        var storedLocalTime = $window.moment.tz(meetings[i].startDate, timezone);
                        var utcTime = storedLocalTime.clone().utc();
                        var deviceLocalTime = utcTime.clone().local();
                        if (currentDate && currentDate.isSame(deviceLocalTime, 'day')) {
                            meetings[i].startDate = deviceLocalTime.format('h:mm A');
                            meetings[i].startTime = deviceLocalTime.toString();
                            filteredMeetings.push(meetings[i]);
                        }
                    }

                    self.scheduledMeetings = filteredMeetings;
                })
                .catch(function (e) {})
                .finally(function () {
                    self.digest();
                });
        }

        function getAdditionalMessageText(meeting) {
            if (meeting.meetingType === 3) {
                return 'You will need to use the desktop or web app to host webinars';
            } else if (self.activeMeeting) {
                return 'There is a meeting in progress';
            } else {
                var meetingTime = new $window.moment(meeting.startTime);
                var currentTime = new $window.moment();
                if (currentTime.diff(meetingTime, 'minute') < -60) {
                    return 'Available to start 1 hour prior to the scheduled time';
                }
            }

            return '';
        }

        function shouldDisable(meeting) {
            if (self.getAdditionalMessageText(meeting) !== '') {
                return true;
            }
            return false;
        }

        function logOut() {
            helperService.mobileConfirm('Do you want to log out?', '', function (response) {
                if (response === 1) {
                    cookieService.remove('aat');
                    $window.localStorage.clear();
                    if (meetingService.isIntermediaPLRUser()) {
                        helperService.setMobileLocation('gomeet.com');
                    } else {
                        helperService.setMobileLocation('anymeeting.com');
                    }
                    if ($http.defaults.headers.common && $http.defaults.headers.common.Authorization) {
                        delete $http.defaults.headers.common.Authorization;
                    }
                    helperService.refreshStickyEventListeners();
                    attendeeService.setAttendeeType('attendee');
                    helperService.setMobileHostLoggedIn(false);
                    $timeout(function () {
                        $window.location.reload();
                    });
                    digest();
                }
            });
        }

        function joinMeeting() {
            var meetingAccessCode = self.meetingCode.replace(/[ -]/g, '');
            meetingAPIService
                .getIsHost({
                    meetingCode: meetingAccessCode
                })
                .then(function () {
                    attendeeService.setAttendeeType('host');
                })
                .catch(function (err) {
                    logger.log(err + ' Instantiating as attendee.');
                    attendeeService.setAttendeeType('attendee');
                })
                .finally(function () {
                    //Decide which initial view to show
                    routerService
                        .resolveInitialPath(meetingAccessCode)
                        .then(function (meeting) {
                            meetingService.init(meeting);
                            //supportLinkService.setBaseUrl(meetingService.getBaseUrl());
                            //TODO  Eventually we need to retrieve the company name from the DB and initialize/set it somewhere.
                            $window.document.title =
                                meetingService.getCompanyName() +
                                ' Web Conferencing, Video Conferencing and Webinar Software';
                            $state.go('meeting-login', {
                                meetingAccessCode: meetingAccessCode
                            });
                        })
                        .catch(function (err) {
                            logger.error('joinMeeting', 'Error during resolveInitialPath', err);
                        });
                });
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
